/* Scent Supply · vessel landing + campaign sections (ss-vessel-*, ss-campaign-*) */
(() => {
if (window.__ssvLoaded) return;
window.__ssvLoaded = true;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const money = (cents) => '$' + (cents / 100).toFixed(2);
const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
/* ---------- Scroll effects: zoom-out photos + fade-up reveals ---------- */
const io = 'IntersectionObserver' in window
? new IntersectionObserver((entries) => {
entries.forEach((e) => {
if (!e.isIntersecting) return;
e.target.classList.add('is-in');
io.unobserve(e.target);
});
}, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' })
: null;
function observe(root) {
root.querySelectorAll('[data-ssv-zoom]:not(.is-in), [data-ssv-reveal]:not(.is-in)').forEach((el) => {
if (!io || reduceMotion) { el.classList.add('is-in'); return; }
io.observe(el);
});
}
/* ---------- Cart ---------- */
async function addItems(items, errorEl, busyEls = []) {
const drawer = document.querySelector('cart-drawer');
const useDrawer = drawer && drawer.dataset.cartType === 'drawer' && typeof drawer.renderContents === 'function';
busyEls.forEach((b) => b.setAttribute('aria-busy', 'true'));
if (errorEl) errorEl.hidden = true;
try {
const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items, sections: useDrawer ? 'cart-drawer,cart-icon-bubble' : undefined, sections_url: window.location.pathname })
});
const json = await res.json();
if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart');
if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ssv', cartData: json }); } catch (_) {} }
if (useDrawer && json.sections) {
drawer.classList.remove('is-empty');
drawer.renderContents({ sections: json.sections }, !drawer.isOpen);
} else {
window.location.href = (window.routes && window.routes.cart_url) || '/cart';
}
} catch (err) {
if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
} finally {
busyEls.forEach((b) => b.removeAttribute('aria-busy'));
}
}
/* ---------- Story video mute toggle ---------- */
function initMute(root) {
root.querySelectorAll('[data-ssv-mute]').forEach((btn) => {
if (btn.dataset.bound) return;
btn.dataset.bound = '1';
const video = document.getElementById(btn.getAttribute('aria-controls'));
if (!video) return;
btn.addEventListener('click', () => {
video.muted = !video.muted;
if (!video.muted) video.play().catch(() => {});
btn.setAttribute('aria-pressed', String(!video.muted));
btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
});
});
}
/* ---------- Gallery (mobile slider; desktop is a static grid) ---------- */
function initGallery(root) {
root.querySelectorAll('[data-ssv-gallery]').forEach((g) => {
if (g.dataset.bound) return;
g.dataset.bound = '1';
const track = g.querySelector('.ssv-gallery__track');
const slides = [...g.querySelectorAll('.ssv-gallery__slide')];
const thumbs = [...g.querySelectorAll('.ssv-thumb')];
if (!track || slides.length < 2) return;
const current = () => (track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0);
const go = (i) => {
const n = (i + slides.length) % slides.length;
track.scrollTo({ left: n * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
};
const sync = () => {
const i = current();
const visible = !g.closest('[hidden]');
thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
slides.forEach((s, k) => {
const v = s.querySelector('video');
if (v) { if (k === i && visible) v.play().catch(() => {}); else if (window.innerWidth < 990) v.pause(); }
const m = s.querySelector('[data-ssv-zoom]');
if (m && k === i && visible) m.classList.add('is-in');
});
};
g.ssvSync = () => { track.scrollLeft = 0; sync(); };
g.querySelector('.ssv-arrow--prev')?.addEventListener('click', () => go(current() - 1));
g.querySelector('.ssv-arrow--next')?.addEventListener('click', () => go(current() + 1));
thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
let raf;
track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
sync();
});
}
/* ---------- Buy box: vessel + refill + Refill Club ---------- */
function initBuy(root) {
root.querySelectorAll('[data-ssv-buy]').forEach((box) => {
if (box.dataset.bound) return;
box.dataset.bound = '1';
const dataEl = box.querySelector('script[data-ssv-data]');
if (!dataEl) return;
const data = JSON.parse(dataEl.textContent);
data.refills.forEach((r) => { r.scentKey = slug(r.scent); });
const form = box.querySelector('form');
const step3 = box.querySelector('[data-ssv-step3]');
const freqWrap = box.querySelector('[data-ssv-freqs]');
const onceLabel = box.querySelector('[data-ssv-once-price]');
const clubLabel = box.querySelector('[data-ssv-club-price]');
const clubSave = box.querySelector('[data-ssv-club-save]');
const atcs = [...document.querySelectorAll(`[data-ssv-atc="${box.id}"]`)];
const summaryEls = [...document.querySelectorAll(`[data-ssv-summary="${box.id}"]`)];
const errorEl = box.querySelector('[data-ssv-error]');
const bar = document.querySelector(`[data-ssv-bar="${box.id}"]`);
const visible = () => !box.hidden && !box.closest('[hidden]');
const state = () => {
const refillId = form.querySelector('input[name="ssv-refill"]:checked')?.value || 'none';
const refill = data.refills.find((r) => String(r.variant) === refillId) || null;
const plan = form.querySelector('input[name="ssv-plan"]:checked')?.value || 'once';
let sp = null;
if (refill && plan === 'club' && refill.plans.length) {
const chosen = form.querySelector('input[name="ssv-freq"]:checked')?.value;
sp = refill.plans.find((p) => String(p.id) === chosen) || refill.plans[0];
}
return { refill, sp };
};
const renderFreqs = (refill) => {
if (!freqWrap) return;
refill = refill || data.refills[0];
const prev = form.querySelector('input[name="ssv-freq"]:checked')?.value;
const prevLabel = refill?.plans.find((p) => String(p.id) === prev)?.label;
freqWrap.innerHTML = '';
(refill?.plans || []).forEach((p, i) => {
const lab = document.createElement('label');
lab.className = 'ssv-freq';
lab.innerHTML = `<input type="radio" name="ssv-freq" id="${box.id}-freq-${p.id}" value="${p.id}"><span>${p.label}</span>`;
freqWrap.appendChild(lab);
const input = lab.querySelector('input');
if ((prevLabel && p.label === prevLabel) || (!prevLabel && i === (refill.defaultPlan ?? 0))) input.checked = true;
});
if (!freqWrap.querySelector('input:checked') && freqWrap.querySelector('input')) freqWrap.querySelector('input').checked = true;
};
const announce = () => {
if (!visible()) return;
const s = state();
document.dispatchEvent(new CustomEvent('ssv:refill-change', { detail: { box: box.id, scent: s.refill?.scentKey || null } }));
};
const render = () => {
const s = state();
const hasRefill = !!s.refill;
if (step3) { step3.disabled = !hasRefill; step3.hidden = false; }
const clubOn = hasRefill && form.querySelector('input[name="ssv-plan"]:checked')?.value === 'club';
if (freqWrap) { freqWrap.hidden = false; freqWrap.classList.toggle('is-muted', hasRefill && !clubOn); }
form.querySelector('input[name="ssv-plan"][value="club"]')?.closest('.ssv-opt')?.classList.toggle('is-muted', hasRefill && !clubOn);
const ref = s.refill || data.refills[0];
if (ref) {
if (onceLabel) onceLabel.textContent = money(ref.price);
const sample = s.sp || ref.plans[0];
if (clubLabel) clubLabel.textContent = sample ? money(sample.price) : '';
if (clubSave) clubSave.textContent = sample && sample.price < ref.price ? ` · save ${Math.round((1 - sample.price / ref.price) * 100)}%` : '';
}
const refillCost = !hasRefill ? 0 : (s.sp ? s.sp.price : s.refill.price);
const total = data.vessel.price + refillCost;
const available = data.vessel.available && (!hasRefill || s.refill.available);
atcs.forEach((b) => {
b.textContent = available ? `${data.labels.add} — ${money(total)}` : data.labels.soldout;
b.toggleAttribute('disabled', !available);
});
let summary = data.labels.emptySummary;
if (hasRefill) {
summary = s.sp
? `${data.labels.vessel} ${money(data.vessel.price)} + ${s.refill.scent} ${money(s.sp.price)}, then ${s.sp.label.toLowerCase()}`
: `${data.labels.vessel} ${money(data.vessel.price)} + ${s.refill.scent} ${data.labels.refillWord} ${money(s.refill.price)}`;
}
summaryEls.forEach((el) => { el.textContent = summary; });
const pct = Number(box.dataset.promo || 0);
box.querySelectorAll('[data-ssv-promo-price]').forEach((el) => {
el.innerHTML = pct > 0 && available ? `Founders price <b>${money(Math.round(total * (1 - pct / 100)))}</b> <s>${money(total)}</s> · ${pct}% off at checkout` : '';
});
announce();
};
form.addEventListener('change', (e) => {
if (e.target.name === 'ssv-freq') { const c = form.querySelector('input[name="ssv-plan"][value="club"]'); if (c) c.checked = true; }
if (e.target.name === 'ssv-refill') renderFreqs(state().refill);
render();
});
const add = () => {
const s = state();
const items = [{ id: data.vessel.variant, quantity: 1 }];
const giftOn = form.querySelector('input[name="ssv-gift"]')?.checked;
if (giftOn) {
const val = (n) => (form.querySelector(`[name="${n}"]`)?.value || '').trim();
const props = { Gift: 'Yes' };
if (val('ssv-gift-to')) props['Gift to'] = val('ssv-gift-to');
if (val('ssv-gift-msg')) props['Gift message'] = val('ssv-gift-msg');
if (val('ssv-gift-from')) props['Gift from'] = val('ssv-gift-from');
items[0].properties = props;
}
if (s.refill) {
const line = { id: s.refill.variant, quantity: 1 };
if (s.sp) line.selling_plan = s.sp.id;
items.push(line);
}
addItems(items, errorEl, atcs);
};
form.addEventListener('submit', (e) => { e.preventDefault(); add(); });
atcs.filter((b) => !form.contains(b)).forEach((b) => b.addEventListener('click', add));
document.addEventListener('ssv:pick-refill', (e) => {
if (!visible()) return;
const r = data.refills.find((x) => x.handle === e.detail.handle) || data.refills.find((x) => x.scentKey === e.detail.scent);
if (!r) return;
const input = form.querySelector(`input[name="ssv-refill"][value="${r.variant}"]`);
if (input) { input.checked = true; renderFreqs(r); render(); }
const opt = input?.closest('.ssv-opt');
const title = box.querySelector('.ssv-info__head');
const target = window.innerWidth < 990 && title ? title : (box.closest('section') || box);
target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
if (opt) { opt.classList.remove('is-picked'); void opt.offsetWidth; opt.classList.add('is-picked'); setTimeout(() => opt.classList.remove('is-picked'), 1900); }
});
const mainAtc = form.querySelector('[data-ssv-atc]');
if (bar && mainAtc && 'IntersectionObserver' in window) {
new IntersectionObserver(([e]) => {
bar.classList.toggle('is-shown', visible() && !e.isIntersecting && e.boundingClientRect.top < 0);
}).observe(mainAtc);
}
box.ssvActivate = () => { render(); };
box.ssvDeactivate = () => { bar?.classList.remove('is-shown'); };
renderFreqs(state().refill);
render();
});
}
/* ---------- Campaign: one page, all sizes ---------- */
function initCampaign(root) {
root.querySelectorAll('[data-ssv-campaign]').forEach((sec) => {
if (sec.dataset.bound) return;
sec.dataset.bound = '1';
const boxes = [...sec.querySelectorAll('[data-ssv-buy]')];
if (!boxes.length) return;
const show = (key, opts = {}) => {
const target = boxes.find((b) => b.dataset.size === key);
if (!target) return;
const scrollY = window.scrollY;
const prev = boxes.find((b) => !b.hidden);
const prevForm = prev?.querySelector('form');
const prevScent = prev && prevForm ? (() => {
const v = prevForm.querySelector('input[name="ssv-refill"]:checked')?.value;
const d = JSON.parse(prev.querySelector('script[data-ssv-data]').textContent);
const r = d.refills.find((x) => String(x.variant) === v);
return v === 'none' ? 'none' : (r ? slug(r.scent) : null);
})() : null;
const prevPlan = prevForm?.querySelector('input[name="ssv-plan"]:checked')?.value;
boxes.forEach((b) => {
const on = b === target;
if (!on && !b.hidden) b.ssvDeactivate?.();
b.hidden = !on;
});
sec.querySelectorAll('[data-ssv-size-switch]').forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.ssvSizeSwitch === key)));
const form = target.querySelector('form');
if (form && prev && prev !== target) {
if (prevScent === 'none') {
const none = form.querySelector('input[name="ssv-refill"][value="none"]');
if (none) none.checked = true;
} else if (prevScent) {
const d = JSON.parse(target.querySelector('script[data-ssv-data]').textContent);
const r = d.refills.find((x) => slug(x.scent) === prevScent);
const input = r && form.querySelector(`input[name="ssv-refill"][value="${r.variant}"]`);
if (input) input.checked = true;
}
['ssv-gift', 'ssv-gift-to', 'ssv-gift-msg', 'ssv-gift-from'].forEach((n) => {
const a = prevForm.querySelector(`[name="${n}"]`), b = form.querySelector(`[name="${n}"]`);
if (a && b) { if (a.type === 'checkbox') b.checked = a.checked; else b.value = a.value; }
});
const planInput = prevPlan && form.querySelector(`input[name="ssv-plan"][value="${prevPlan}"]`);
if (planInput) planInput.checked = true;
form.dispatchEvent(new Event('change', { bubbles: true }));
const refillInput = form.querySelector('input[name="ssv-refill"]:checked');
if (refillInput) refillInput.dispatchEvent(new Event('change', { bubbles: true }));
}
target.ssvActivate?.();
target.querySelector('[data-ssv-gallery]')?.ssvSync?.();
observe(target);
if (!reduceMotion && opts.animate) { target.classList.remove('is-entering'); void target.offsetWidth; target.classList.add('is-entering'); }
if (opts.keepScroll) window.scrollTo(0, scrollY);
if (opts.updateUrl) {
try { const u = new URL(window.location.href); u.searchParams.set('size', key); history.replaceState(null, '', u); } catch (_) {}
}
document.dispatchEvent(new CustomEvent('ssv:size-change', { detail: { size: key } }));
};
sec.addEventListener('click', (e) => {
const pill = e.target.closest('[data-ssv-size-switch]');
if (!pill) return;
show(pill.dataset.ssvSizeSwitch, { animate: true, keepScroll: true, updateUrl: true });
const again = sec.querySelector(`[data-ssv-buy]:not([hidden]) [data-ssv-size-switch="${pill.dataset.ssvSizeSwitch}"]`);
again?.focus({ preventScroll: true });
});
let initial = null;
try { initial = new URL(window.location.href).searchParams.get('size'); } catch (_) {}
if (!initial && /^#(mini|medium|large)$/i.test(window.location.hash)) initial = window.location.hash.slice(1);
if (initial && boxes.some((b) => b.dataset.size === initial.toLowerCase())) show(initial.toLowerCase(), {});
});
}
/* ---------- Scent tabs ---------- */
function initScents(root) {
root.querySelectorAll('[data-ssv-scents]').forEach((sec) => {
if (sec.dataset.bound) return;
sec.dataset.bound = '1';
const tabs = [...sec.querySelectorAll('[role="tab"]')];
const panels = [...sec.querySelectorAll('[role="tabpanel"]')];
const select = (handle, focus) => {
tabs.forEach((t) => {
const on = t.dataset.handle === handle;
t.setAttribute('aria-selected', String(on));
t.tabIndex = on ? 0 : -1;
if (on && focus) t.focus();
});
panels.forEach((p) => {
p.hidden = p.dataset.handle !== handle;
if (!p.hidden) observe(p);
});
};
tabs.forEach((t, i) => {
t.addEventListener('click', () => select(t.dataset.handle));
t.addEventListener('keydown', (e) => {
if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
select(n.dataset.handle, true);
});
});
sec.querySelectorAll('[data-ssv-pick]').forEach((b) => b.addEventListener('click', () => {
document.dispatchEvent(new CustomEvent('ssv:pick-refill', { detail: { handle: b.dataset.ssvPick, scent: b.dataset.scent } }));
}));
document.addEventListener('ssv:refill-change', (e) => {
const t = tabs.find((x) => x.dataset.scent === e.detail.scent);
if (t) select(t.dataset.handle);
});
});
}
/* ---------- Single-product quick add (discovery set) ---------- */
function initQuickAdd(root) {
root.querySelectorAll('[data-ssv-quick-add]').forEach((btn) => {
if (btn.dataset.bound) return;
btn.dataset.bound = '1';
btn.addEventListener('click', () => {
const err = btn.closest('section')?.querySelector('[data-ssv-error]');
addItems([{ id: Number(btn.dataset.ssvQuickAdd), quantity: 1 }], err, [btn]);
});
});
}
function init(root = document) {
observe(root);
initMute(root);
initGallery(root);
initScents(root);
initBuy(root);
initCampaign(root);
initQuickAdd(root);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
else init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
